import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

import styles from './FallbackLoader.module.scss';

const FallbackLoader: React.FC = () => (
  <div className={styles.container}>
    <CircularProgress color="inherit" />
  </div>
);

export default FallbackLoader;
